












































































import Vue from "vue";
import Component from "vue-class-component";
import Textbox from "@/components/atoms/Textbox.vue";
import AlertMessage from "@/components/atoms/AlertMessage.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: { Textbox, AlertMessage },
})
export default class ChangePassword extends Vue {
  name: "ChangePassword";

  private securityCode = "";
  private currentPassword = "";
  private newPassword = "";
  private newPasswordConfirm = "";

  @Prop({ required: true })
  private isLoggedIn: boolean;

  private onClickChangePasswordButton(): void {
    this.$emit(
      "on-click-change-password-button",
      this.securityCode,
      this.currentPassword,
      this.newPassword,
      this.newPasswordConfirm
    );
  }

  private onClickCancelButton(): void {
    this.$emit("on-click-cancel-button");
  }
}
